import firebase from "firebase";

const designTags = () => firebase.firestore().collection("designTags");

export default {
  async list() {
    const snapshot = await designTags()
      .orderBy("order")
      .get();
    return snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
  },

  create(name, order) {
    return designTags().add({ name, order });
  },

  rename(id, name) {
    return designTags()
      .doc(id)
      .update({ name });
  },

  reorder(tags) {
    const batch = firebase.firestore().batch();
    tags.forEach((tag, index) => {
      batch.update(designTags().doc(tag.id), { order: index + 1 });
    });
    return batch.commit();
  },

  remove(id) {
    return designTags()
      .doc(id)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/services/DesignTagsService.js